<header class="vl-functional-header vl-functional-header--has-actions" role="banner" style="margin-bottom: 0px">
  <div class="vl-layout vl-u-spacer">
    <div class="vl-functional-header__row">
      <div class="vl-functional-header__content">
        <img height="35" width="140" src="assets/images/Entiteitslogo_ANB_zwartwit.png" alt="Agentschap Natuur & Bos" id="logonatuurenbos" />
      </div>
      <div class="vl-functional-header__actions" *ngIf="anbAuthService.hasAuthenticatedSession">
        <ul>
          <li class="vl-functional-header__action">
            <p>{{ anbAuthService.principalName }}</p>
          </li>
          <li class="vl-functional-header__action">
            <p>
              <a class="pointer" (click)="logout()">{{ 'HEADER.LOGOUT' | translate }}</a>
            </p>
          </li>
        </ul>
      </div>
    </div>
  </div>
  <div class="sub-header">
    <div class="vl-layout">
      <div class="vl-grid vl-grid--v-center">
        <div class="vl-col--12-12 vl-col--12-12--m vl-col--12-12--s vl-col--1-1--xs">
          <div class="wrapper">
            <div class="vl-title align-left">
              {{ title }}
            </div>
            <div class="vl-action-group vl-action-group--bordered vl-action-group--align-right">
              <ng-container [ngTemplateOutlet]="secondaryMenuTemplate"> </ng-container>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</header>

<div class="vl-layout vl-layout--wide vl-u-spacer--small" style="margin-bottom: 0px">
  <div class="vl-grid">
    <div class="vl-col--12-12 vl-col--12-12--m vl-col--12-12--s vl-col--1-1--xs">
      <ng-container [ngTemplateOutlet]="primaryMenuTemplate"> </ng-container>
    </div>
  </div>
</div>
